import React from 'react';
import './ResellersCommonQuestions.scss';
import FAQs from '../../FAQs/FAQs';

const ResellersCommonQuestions = ({ title, faqs, backgroundColor }) => (
  <div className="c-resellers-common-questions">
    <FAQs title={title} faqs={faqs} backgroundColor={backgroundColor} />
  </div>
);

export default ResellersCommonQuestions;
